// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___3v6l4","m-signature-pad--body":"styles__m-signature-pad--body___33PXI","m-signature-pad--footer":"styles__m-signature-pad--footer___12PYt","description":"styles__description___17Xis","button":"styles__button___3F4VE","clear":"styles__clear___32IPy","save":"styles__save___2XGbj","m-signature-pad":"styles__m-signature-pad___3PUac","github":"styles__github___1xxpP","label":"styles__label___3daOg","text":"styles__text___fmGHa","errorLabel":"styles__errorLabel___2xtsF","errorMsg":"styles__errorMsg___2TDMg"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/RadioButtons/styles.scss
// module id = dZ0t
// module chunks = client